export * from "./src/clientsvc";
//# sourceMappingURL=index.js.map